export default __webpack_public_path__ + "static/media/elementary.cf393522.svg";